export default __webpack_public_path__ + "static/media/line-diamonds.17a32150.png";